import type { ExternalTableSchema } from '@packages/table-builder';

export const sandboxTable: ExternalTableSchema = {
  metadata: {
    title: 'Sandbox',
    entity: 'Sandbox',
    description: 'List of sandbox instances.',
  },

  dataSource: {
    endpoint: '/api/identity/api/sandbox',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    {
      field: 'name',
      header: 'Name',
      type: 'text',
      width: 200,
      align: 'left',
      sortable: true,
    },
    {
      field: 'description',
      header: 'Description',
      type: 'text',
      width: 200,
      align: 'left',
      sortable: true,
      emptyText: '-',
    },
    {
      field: 'initializationStatus',
      header: 'Status',
      type: 'badge',
      width: 180,
      align: 'center',
      badge: {
        statusMap: {
          Initialized: 'success',
          Initializing: 'info',
          'Initialization Failed': 'error',
          'Deletion In Progress': 'error',
        },
      },
    },
    {
      field: 'fromTenantName',
      header: 'Copied From',
      type: 'text',
      width: 200,
      align: 'left',
    },
    {
      field: 'createdAt',
      header: 'Created Datetime',
      type: 'dateTime',
      width: 220,
      align: 'left',
      sortable: true,
    },
    {
      field: 'createdBy',
      header: 'Created By',
      type: 'text',
      width: 150,
      align: 'left',
      sortable: true,
    },
    {
      field: 'visibility',
      header: 'Sandbox Type',
      type: 'badge',
      width: 180,
      align: 'center',
      badge: {
        statusMap: {
          Private: 'pink-tag',
          Public: 'primary',
        },
      },
    },
    {
      field: 'tenantState',
      header: 'Access Status',
      type: 'badge',
      width: 180,
      align: 'center',
      badge: {
        statusMap: {
          Locked: 'pink-tag',
          Full: 'primary',
        },
      },
    },
  ],

  actions: {
    row: [
      { id: 'LOAD_TO_MAIN_ROW_SANDBOX', label: 'Load to Main' },
      { id: 'EDIT_SANDBOX', label: 'Edit' },
      { id: 'SHARE_SANDBOX', label: 'Share' },
      { id: 'CONVERT_TO_PUBLIC_SANDBOX', label: 'Convert to Public' },
      { id: 'CHANGE_STATUS_SANDBOX', label: 'Change Status' },
      { id: 'DELETE_SANDBOX', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_SANDBOX',
        label: 'Add Sandbox',
        icon: 'add_circle_outline',
      },
      secondary: [
        {
          id: 'LOAD_TO_MAIN_SANDBOX',
          label: 'Load To Main',
          icon: 'add_circle_outline',
          variant: 'primary-outline',
        },
      ],
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
  },
};
